import React from 'react';
import clsx from 'clsx';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: 400,
      '&>div': {
        flexBasis: '46%',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: 420,
      },
    },
  }),
);

interface Props {
  children: React.ReactNode;
  className?: string;
}

const SocialWrapper: React.FC<Props> = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return <div className={clsx(classes.root, className)}>{children}</div>;
};

export default SocialWrapper;
